// extracted by mini-css-extract-plugin
export default {"activeSideItem":"Sidebar_activeSideItem__LFb0f"};